// extracted by mini-css-extract-plugin
module.exports = {"deferredContent":"HomepagePerformance_deferredContent__K_d8O"};